module.exports = __webpack_public_path__ + "img/adv.0c11dc2d.png";